import { REPORTS_MANAGEMENT_STATE_KEY } from './reports-reducer';

export const getReportsLoading = (state, fileName) =>
  state[REPORTS_MANAGEMENT_STATE_KEY].loadingReportNames.includes(fileName);
export const getSelectedReport = (state) => state[REPORTS_MANAGEMENT_STATE_KEY].selectedReport;
